// Optional stages use exact instants; existing single-period gardens keep their date semantics.
export function getSeasonalPresale(config, now = new Date()) {
  if (!config || config.active != true) return null;

  if (Array.isArray(config.periods)) {
    if (now < new Date(config.periodStart) || now > new Date(config.periodEnd)) return null;
    return config.periods.find(period =>
      now >= new Date(period.periodStart) && now <= new Date(period.periodEnd)
    ) || null;
  }

  const day = new Date(now.toJSON().slice(0, 10) + 'T00:00:00+0200');
  return day >= new Date(config.periodStart) && day <= new Date(config.periodEnd) ? config : null;
}
